import React from "react";
import { createPortal } from "react-dom";

// Rendered straight into <body>: inside a page container that has its own
// z-index (e.g. .main-content) the overlay could never rise above the fixed
// header, title strip or tab bar, so their text showed on top of the loader.
const Loader = () => {
  const loader = (
    <div class="loader_class">
      <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  );
  return typeof document !== "undefined" ? createPortal(loader, document.body) : loader;
}

export default Loader;
